// Copyright (c) 2018 Deere & Company

import {
    updatePartsClaimInputOnBlur,
    updateResponsibleAccountsDropDown
} from '../action-creators/claim-details';
import {doesAccountHaveMatch} from '../../shared/services/claim-shared-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';

export const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, pin) =>

    dispatch => {

        if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

            updateResponsibleAccountsDropDown(productAccountId, dealerCollection, pin)(dispatch);
            dispatch(updatePartsClaimInputOnBlur('responsibleAccount', productAccountId));

        }

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };



// WEBPACK FOOTER //
// ./src/claim/parts/services/update-responsible-account.js